export default __webpack_public_path__ + "static/media/kanit-light.45fd3241.svg";